import IntroBanner from './IntroBanner';

export default IntroBanner;
